// 产品页公用展开收缩
document.addEventListener("DOMContentLoaded", function () {
  const titles = document.querySelectorAll(
    ".description-content-module__title"
  );

  titles.forEach((title) => {
    title.addEventListener("click", function () {
      const contentBox = this.nextElementSibling;

      if (
        contentBox &&
        contentBox.classList.contains("description-content-module__Textbox")
      ) {
        if (contentBox.style.maxHeight) {
          contentBox.style.maxHeight = null;
        } else {
          contentBox.style.maxHeight = contentBox.scrollHeight + "px";
        }
        this.classList.toggle("active");
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document
    .querySelectorAll(".description-ingredients-module__title")
    .forEach((title) => {
      title.addEventListener("click", function () {
        let textBox = this.nextElementSibling; // 获取对应的 Textbox
        this.classList.toggle("active"); // 切换 active 类
        if (textBox) {
          if (textBox.classList.contains("expanded")) {
            textBox.style.height = "0"; // 收起
            textBox.classList.remove("expanded");
          } else {
            textBox.style.height = "100%";
            textBox.classList.add("expanded");
          }
        }
      });
    });

  document
    .querySelectorAll(".description-ingredients-module__toggle")
    .forEach((button) => {
      button.addEventListener("click", function (event) {
        event.stopPropagation(); // 防止触发 title 的点击事件
        let content = this.previousElementSibling; // 获取 .description-ingredients-module__content
        let toggleText = this.querySelector(
          ".description-ingredients-button__toggle"
        );
        if (content) {
          if (content.classList.contains("full")) {
            content.style.height = "50px"; // 收起
            content.classList.remove("full");
            toggleText.textContent = "Show More";
          } else {
            content.style.height = content.scrollHeight + "px"; // 展开所有内容
            content.classList.add("full");
            toggleText.textContent = "Show Less";
          }
        }
      });
    });
});
